var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanceled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0.75C13.8 0.75 0.75 13.8 0.75 30C0.75 46.2 13.8 59.25 30 59.25V0.75Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59.25C46.2 59.25 59.25 46.2 59.25 30C59.25 13.8 46.2 0.75 30 0.75V59.25Z",
    fill: "#DEE6F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 22.875C31.8752 21 33.7502 19.05 35.7002 17.175C38.4752 14.55 42.9002 15.75 44.0252 19.425C44.5502 21.225 44.1752 22.875 42.9002 24.225C41.1752 26.1 39.3002 27.825 37.5002 29.625C37.2002 29.925 37.2002 30.075 37.5002 30.375C39.3002 32.175 41.1002 33.9 42.8252 35.7C45.3002 38.25 44.3252 42.45 41.1002 43.8C39.2252 44.625 37.0502 44.175 35.4752 42.6C33.6002 40.8 31.8002 38.925 29.9252 37.125C29.7002 36.9 29.7002 36.6 29.7002 36.375C29.7002 32.1 29.7002 27.825 29.7002 23.625C29.7752 23.325 29.7752 23.025 30.0002 22.875Z",
    fill: "#CC0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 22.875C29.9999 27.675 29.9999 32.4 29.9999 37.2C29.9249 37.275 29.9249 37.275 29.8499 37.35C28.0499 39.15 26.1749 40.95 24.3749 42.75C22.4999 44.55 19.8749 44.775 17.8499 43.275C15.3749 41.475 14.9999 37.95 17.0999 35.775C18.8249 33.975 20.6999 32.175 22.4999 30.375C22.7999 30.075 22.7999 29.925 22.4999 29.625C20.6999 27.825 18.8999 26.1 17.1749 24.3C14.5499 21.525 15.7499 17.025 19.4999 15.975C21.3749 15.45 23.0249 15.9 24.3749 17.25C26.0999 18.9 27.8249 20.625 29.4749 22.35C29.6249 22.5 29.7749 22.575 29.8499 22.725C29.9249 22.725 29.9999 22.8 29.9999 22.875Z",
    fill: "#FE4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceled);
export default __webpack_public_path__ + "static/media/canceled.8f9dbe9ae66d4f0afc9f65c045eaf3ca.svg";
export { ForwardRef as ReactComponent };